import { Fragment } from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { BellIcon, UserIcon } from "@heroicons/react/24/outline";
import { AuthService } from "../../Modules/Auth/services/AuthService";
import { LoginResponse } from "../../Modules/Auth/models/LoginResponse";
import { GenericLink } from "./GenericLink";
import { UtilService } from "../Utils/UtilService";
import { useTranslation } from "react-i18next";

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export const UserProfile = () => {
  const currentUser: LoginResponse | null = AuthService.getLocalUser();
  const logoutAction = () => AuthService.logout();
const [t] = useTranslation()
  return (
    <>
      <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
        <button
          type="button"
          className="relative rounded-full bg-blue-800 p-1 text-white hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-800"
        >
          <div className="p-1">
            <span className="sr-only">{t('view_notifications')}</span>
            <BellIcon className="h-6 w-6" aria-hidden="true" />
          </div>
        </button>

        <Menu as="div" className="relative ml-6">
          <div>
            <MenuButton className="relative flex rounded-full text-white hover:text-gray-400 bg-blue-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-800">
              <div className="p-2">
                <span className="sr-only">{t('open_user_menu')}</span>
                <UserIcon className="h-6 w-6 text" aria-hidden="true" />
              </div>
            </MenuButton>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none">
              <div className="py-1">
                <MenuItem>
                  {(active) => (
                    <GenericLink
                      to="/services/settings/account"
                      label={
                        currentUser?.user
                          ? `${UtilService.titleCase(
                              currentUser?.user?.firstName ?? ""
                            )} ${UtilService.titleCase(
                              currentUser?.user?.lastName ?? ""
                            )}`
                          : t('create_profile')
                      }
                      className={classNames(
                        active ? "cursor-pointer" : "",
                        "block px-4 py-2 text-sm text-gray-700"
                      )}
                    />
                  )}
                </MenuItem>

                <MenuItem>
                  {(active) => (
                    <GenericLink
                      to="/services/settings/account"
                      label={t('menu_settings')}
                      className={classNames(
                        active ? "cursor-pointer" : "",
                        "block px-4 py-2 text-sm text-gray-700"
                      )}
                    />
                  )}
                </MenuItem>

                <MenuItem>
                  {(active) => (
                    <div
                      onClick={logoutAction}
                      className={classNames(
                        active ? "cursor-pointer" : "",
                        "block px-4 py-2 text-sm text-gray-700"
                      )}
                    >
                      {t('signout')}
                    </div>
                  )}
                </MenuItem>
              </div>
            </MenuItems>
          </Transition>
        </Menu>
      </div>
    </>
  );
};
